(function() {
    'use strict';

a3_cabin_reports.factory('SupplyFactory', SupplyFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SupplyFactory
    * @description 
    *   Manage Report's Supplies.
    * @ngInject
    */
function SupplyFactory(GenericModalFactory) {

        /**
         * Initialiaze a object 
         * @memberof SupplyFactory
         */
		function Supply() {
			this.SupplyType = null;
			this.Remarks = null;
		}
	
		var service = {
			createNew : createNew,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
		}
		
        /**
         * Initialiaze Supply object 
         * @memberof SupplyFactory
         */
		function createNew() {
			return GenericModalFactory.createNew(Supply)
		}

        /**
         * Extend given Supply object 
         * @memberof SupplyFactory
         * @param {object} obj The Supply object that will be extended
         * @returns {object} Supply
         */  
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,Supply)
		}

        /**
         * Delete Supply object from given list
         * @memberof SupplyFactory
         * @param {object} obj The Supply object that will be deleted
         * @returns {array} Supplies
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
		
        /**
         * Extend given Supply object List 
         * @memberof SupplyFactory
         * @param {object} obj The Supply object that will be extended
         * @returns {array} Supplies
         */
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,Supply)
		}

		return service;
	}

})();
